import $ from 'jquery';
import 'bootstrap-sass/assets/javascripts/bootstrap/tooltip';

const loadProductDiagrams = () => {
  const $productDiagrams = $('.product-anatomy-exploded');

  $.each($productDiagrams, (index, diagram) => {
    const $productParts = $(diagram).find('.diagram-dynamic > img');

    $.each($productParts, (index, part) => {
      const key = part.id.replace('component-', '');
      const html = $(diagram).find('#annotation-' + key).html();

      $(part).tooltip({
        placement: 'right',
        html: true,
        title: html,
        template: `
          <div class="tooltip product-anatomy-tooltip" role="tooltip">
            <div class="tooltip-arrow"></div>
            <div class="tooltip-inner"></div>
          </div>
        `,
        container: 'body'
      });
    });

    $productParts.on('mouseenter', function() {
      $productParts.css('opacity', 0.5);
      $(this).css('opacity', 1);
    });

    $productParts.on('mouseleave', function() {
      $productParts.css('opacity', 1);
    });
  });
};

export default loadProductDiagrams;
